import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "reception-page letter-spacing" }
const _hoisted_2 = { class: "row g-3" }
const _hoisted_3 = { class: "col-12 col-xl-6" }
const _hoisted_4 = { class: "rc-card h-100" }
const _hoisted_5 = { class: "rc-body" }
const _hoisted_6 = { class: "rc-input-icon" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_9 = {
  key: 1,
  class: "flaticon-search"
}
const _hoisted_10 = { class: "row g-3" }
const _hoisted_11 = { class: "col-12 col-md-6" }
const _hoisted_12 = { class: "col-12 col-md-6" }
const _hoisted_13 = {
  key: 0,
  class: "rc-selected"
}
const _hoisted_14 = {
  key: 0,
  class: "rc-foot"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "col-12 col-xl-6 d-flex flex-column gap-3" }
const _hoisted_17 = { class: "rc-card" }
const _hoisted_18 = { class: "rc-body" }
const _hoisted_19 = {
  key: 0,
  class: "rc-foot"
}
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "rc-card" }
const _hoisted_22 = { class: "rc-body" }
const _hoisted_23 = {
  key: 0,
  class: "rc-foot"
}
const _hoisted_24 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "page-head" }, [
      _createElementVNode("h3", { class: "mb-1" }, "Nouvelle réception"),
      _createElementVNode("p", { class: "text-muted mb-0" }, "Choisissez le type de réception à créer, puis validez pour ouvrir la note.")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("section", _hoisted_4, [
          _cache[18] || (_cache[18] = _createElementVNode("header", { class: "rc-head" }, [
            _createElementVNode("span", { class: "rc-icon" }, [
              _createElementVNode("i", { class: "ph ph-storefront" })
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h4", null, "Réception client"),
              _createElementVNode("small", null, "Par store, avec recherche via un code de suivi")
            ]),
            _createElementVNode("span", { class: "rc-badge" }, "CLIENT")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _cache[15] || (_cache[15] = _createElementVNode("label", { class: "rc-label" }, "Retrouver le store via un code de suivi", -1)),
            _createElementVNode("form", {
              class: "rc-inline",
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.getCstmr && _ctx.getCstmr(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_6, [
                _cache[9] || (_cache[9] = _createElementVNode("i", { class: "ph ph-barcode" }, null, -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.codeColis) = $event)),
                  type: "text",
                  class: "form-control",
                  placeholder: "Scannez ou saisissez le code de suivi",
                  autocomplete: "off"
                }, null, 512), [
                  [_vModelText, _ctx.codeColis]
                ])
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary rc-btn",
                disabled: _ctx.isLoader || !_ctx.codeColis.trim()
              }, [
                (_ctx.isLoader)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8))
                  : (_openBlock(), _createElementBlock("i", _hoisted_9))
              ], 8, _hoisted_7)
            ], 32),
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "rc-divider" }, [
              _createElementVNode("span", null, "ou choisir manuellement")
            ], -1)),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[11] || (_cache[11] = _createElementVNode("label", { class: "rc-label" }, "Store", -1)),
                _createVNode(_component_v_select, {
                  options: _ctx.clientsList,
                  class: "custom-select-height",
                  modelValue: _ctx.cstmrColi,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cstmrColi) = $event)),
                  label: "customer_name",
                  placeholder: "Rechercher un store",
                  onSearch: _ctx.onSearchClients
                }, {
                  "no-options": _withCtx(() => _cache[10] || (_cache[10] = [
                    _createTextVNode("Taper un mot pour chercher un store", -1)
                  ])),
                  option: _withCtx((option) => [
                    _createElementVNode("span", null, _toDisplayString(option.customer_name) + " - " + _toDisplayString(option.nb_colis) + " (Colis)", 1)
                  ]),
                  _: 1
                }, 8, ["options", "modelValue", "onSearch"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[12] || (_cache[12] = _createElementVNode("label", { class: "rc-label" }, "Agence", -1)),
                _createVNode(_component_v_select, {
                  class: "custom-select-height",
                  label: "name",
                  options: _ctx.agencyList,
                  placeholder: "Choisir une agence",
                  modelValue: _ctx.agency,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.agency) = $event))
                }, null, 8, ["options", "modelValue"])
              ])
            ]),
            (_ctx.cstmrColi && _ctx.cstmrColi.customer_name)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _cache[14] || (_cache[14] = _createElementVNode("i", { class: "ph ph-check-circle" }, null, -1)),
                  _createElementVNode("span", null, [
                    _cache[13] || (_cache[13] = _createTextVNode("Store sélectionné : ", -1)),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.cstmrColi.customer_name), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.auth.can('ADD_RECEPTION'))
            ? (_openBlock(), _createElementBlock("footer", _hoisted_14, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  disabled: _ctx.isLoader,
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addCstmrColi && _ctx.addCstmrColi(...args)))
                }, _cache[17] || (_cache[17] = [
                  _createElementVNode("i", { class: "ph ph-plus-circle me-1" }, null, -1),
                  _createTextVNode(" Créer la réception ", -1)
                ]), 8, _hoisted_15)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("section", _hoisted_17, [
          _cache[21] || (_cache[21] = _createElementVNode("header", { class: "rc-head" }, [
            _createElementVNode("span", { class: "rc-icon rc-icon--blue" }, [
              _createElementVNode("i", { class: "ph ph-globe-hemisphere-west" })
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h4", null, "Réception globale"),
              _createElementVNode("small", null, "Tous les colis d'une agence")
            ]),
            _createElementVNode("span", { class: "rc-badge rc-badge--blue" }, "GLOBAL")
          ], -1)),
          _createElementVNode("div", _hoisted_18, [
            _cache[19] || (_cache[19] = _createElementVNode("label", { class: "rc-label" }, "Agence", -1)),
            _createVNode(_component_v_select, {
              class: "custom-select-height",
              label: "name",
              modelValue: _ctx.gobalAgency,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.gobalAgency) = $event)),
              options: _ctx.agencyList,
              placeholder: "Choisir une agence"
            }, null, 8, ["modelValue", "options"])
          ]),
          (_ctx.auth.can('ADD_RECEPTION'))
            ? (_openBlock(), _createElementBlock("footer", _hoisted_19, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  disabled: _ctx.isLoader,
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addGlobalNote && _ctx.addGlobalNote(...args)))
                }, _cache[20] || (_cache[20] = [
                  _createElementVNode("i", { class: "ph ph-plus-circle me-1" }, null, -1),
                  _createTextVNode(" Créer la réception ", -1)
                ]), 8, _hoisted_20)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("section", _hoisted_21, [
          _cache[24] || (_cache[24] = _createElementVNode("header", { class: "rc-head" }, [
            _createElementVNode("span", { class: "rc-icon rc-icon--green" }, [
              _createElementVNode("i", { class: "ph ph-package" })
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h4", null, "Réception stock"),
              _createElementVNode("small", null, "Colis de stock par agence")
            ]),
            _createElementVNode("span", { class: "rc-badge rc-badge--green" }, "STOCK")
          ], -1)),
          _createElementVNode("div", _hoisted_22, [
            _cache[22] || (_cache[22] = _createElementVNode("label", { class: "rc-label" }, "Agence", -1)),
            _createVNode(_component_v_select, {
              label: "stock_agency_name",
              class: "custom-select-height",
              modelValue: _ctx.stockAgency,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.stockAgency) = $event)),
              options: _ctx.agencyStockList,
              placeholder: "Choisir une agence"
            }, {
              option: _withCtx((option) => [
                _createElementVNode("span", null, _toDisplayString(option.stock_agency_name) + " - " + _toDisplayString(option.nb_colis) + " Colis", 1)
              ]),
              _: 1
            }, 8, ["modelValue", "options"])
          ]),
          (_ctx.auth.can('ADD_RECEPTION'))
            ? (_openBlock(), _createElementBlock("footer", _hoisted_23, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  disabled: _ctx.isLoader,
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.addStockNote && _ctx.addStockNote(...args)))
                }, _cache[23] || (_cache[23] = [
                  _createElementVNode("i", { class: "ph ph-plus-circle me-1" }, null, -1),
                  _createTextVNode(" Créer la réception ", -1)
                ]), 8, _hoisted_24)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}